<template>
  <q-dialog
    v-model="shown"
    persistent
  >
    <q-card
      data-test-id="select-kds-station-card"
    >
      <q-inner-loading
        style="z-index: 1;"
        :showing="loading"
      />
      <q-card-section
        v-if="currentUser"
        class="column items-center"
      >
        <q-select
          v-model="currentUser.circuitId"
          data-test-id="circuit-select"
          class="set-kitchen-display-dialog-select q-mr-md q-my-sm full-width"
          label="Circuit"
          bg-color="white"
          :options="currentUser.authorizedCircuitOptions"
          option-label="name"
          option-value="id"
          map-options
          emit-value
          :disable="loading"
          @update:model-value="handleCircuitChange()"
        />
        <q-select
          v-if="!userCircuitMigratedUrl"
          v-model="siteId"
          data-test-id="site-select"
          class="set-kitchen-display-dialog-select q-mr-md q-my-sm full-width"
          label="Site"
          bg-color="white"
          :options="currentUser.authorizedSiteOptions"
          option-label="name"
          option-value="id"
          map-options
          emit-value
          :disable="loading"
          :readonly="!currentUser.authorizedSiteOptions.length"
          @update:model-value="handleSiteChange()"
        >
          <q-tooltip v-if="!currentUser.authorizedSiteOptions.length">
            No sites available for this circuit.
          </q-tooltip>
        </q-select>
        <q-select
          v-if="!userCircuitMigratedUrl"
          v-model="kitchenDisplay"
          data-test-id="kitchen-display-select"
          class="set-kitchen-display-dialog-select q-mr-md q-my-sm full-width"
          label="Kitchen Display"
          bg-color="white"
          :options="kitchenDisplayOptions"
          option-label="name"
          map-options
          :disable="loading"
          :read-only="!kitchenDisplayOptions.length"
          @update:model-value="setKitchenDisplay()"
        >
          <q-tooltip v-if="!kitchenDisplayOptions.length">
            No kitchen displays available for this site.
          </q-tooltip>
        </q-select>
        <div
          v-else
          class="col-auto text-h6"
        >
          This site has been migrated to <a :href="userCircuitMigratedUrl">our new Beta region</a>.
        </div>
      </q-card-section>

      <q-card-actions
        align="right"
      >
        <q-btn
          v-if="!userCircuitMigratedUrl"
          data-test-id="quit-kds-button"
          label="Quit"
          color="primary"
          flat
          @click="quit"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>

import { isElectronMode } from 'src/config'
import KdsClient from 'src/models/kds/KdsClient'

export default {
  name: 'SetKitchenDisplayDialog',
  context: ['currentUser', 'currentKdsClient'],
  configuration: ['kitchenDisplays'],
  props: {
    modelValue: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['update:model-value', 'site-changed'],
  data () {
    return {
      shown: false,
      kitchenDisplay: null,
      siteId: null,
      loading: false
    }
  },
  computed: {
    userCircuitMigratedUrl () {
      return this.currentUser?.circuitMigratedUrl
    },
    kitchenDisplayOptions () {
      if (!this.kitchenDisplays?.data) return []

      return _.filter(this.kitchenDisplays.data, 'isUnarchived')
    }
  },
  watch: {
    modelValue: {
      handler () {
        this.shown = this.modelValue
      },
      immediate: true
    },
    shown () {
      this.$emit('update:model-value', this.shown)
    }
  },
  methods: {
    show () {
      this.shown = true
    },
    hide () {
      this.shown = false
    },
    quit () {
      this.$quitKds()
    },
    async setKitchenDisplay () {
      try {
        this.loading = true

        let kdsClient
        if (this.currentKdsClient) {
          kdsClient = this.currentKdsClient
          kdsClient.kitchenDisplayId = this.kitchenDisplay.id
          kdsClient.isElectronMode = isElectronMode && !window.electronPrinter.status()?.error
        } else {
          kdsClient = new KdsClient({
            kitchenDisplayId: this.kitchenDisplay.id,
            isElectronMode: isElectronMode && !window.electronPrinter.status()?.error
          })
        }

        await kdsClient.save()
      } catch (exception) {
        this.$rollbar.error(`Failed to setKdsStation(), exception: ${exception.message}`)
      } finally {
        this.loading = false
        window.location.reload()
      }
    },
    async handleSiteChange () {
      try {
        this.loading = true
        this.currentUser.siteId = this.siteId
        await this.$changeCircuitOrSite()
        await this.$handleAuthChange()
        this.$emit('site-changed', this.siteId)
      } catch (exception) {
        this.$rollbar.error(`Failed to handleSiteChange(), exception: ${exception.message}`)
      } finally {
        this.loading = false
      }
    },
    async handleCircuitChange () {
      try {
        this.loading = true
        await this.$changeCircuitOrSite()
        await this.$handleAuthChange()
      } catch (exception) {
        this.$rollbar.error(`Failed to handleCircuitChange(), exception: ${exception.message}`)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.set-kitchen-display-dialog-select {
  min-width: 200px;
}
</style>
